<template>
  <div class="box sidemenu">
    <b-menu>
      <b-menu-list label="Settings">
        <b-menu-item @click="navigate('applicationSettings')" :active="isActive('applicationSettings')" icon="cog-box" label="Application"></b-menu-item>
        <b-menu-item @click="navigate('accountSettings')" :active="isActive('accountSettings')" icon="account" label="My Account"></b-menu-item>
      </b-menu-list>
      <b-menu-list label="Actions">
        <b-menu-item :active="false" @click="passwordModalActive = true" icon="lock-reset" label="Password Update"></b-menu-item>
        <b-menu-item @click="navigate('logout')" icon="exit-to-app" label="Logout"></b-menu-item>
      </b-menu-list>
      <b-menu-list label="Legal documents">
        <b-menu-item @click.prevent="showTermsOfUseModal = true" :label="$t('inputs.terms_of_use.title')"></b-menu-item>
        <b-menu-item @click.prevent="showPrivacyNoticeModal = true" :label="$t('inputs.privacy_notice.title')"></b-menu-item>
      </b-menu-list>
    </b-menu>

    <!-- Modals -->
    <b-modal :active.sync="passwordModalActive">
      <UpdatePasswordModal @close="passwordModalActive = false"/>
    </b-modal>
    <b-modal :active.sync="showTermsOfUseModal" width="1500">
      <TermsOfUseModal @close="showTermsOfUseModal = false" />
    </b-modal>
    <b-modal :active.sync="showPrivacyNoticeModal" width="1500">
      <PrivacyNoticeModal @close="showPrivacyNoticeModal = false" />
    </b-modal>
  </div>
</template>

<script>
import UpdatePasswordModal from '@/views/Settings/UpdatePasswordModal'
import TermsOfUseModal from '@/components/modals/TermsOfUseModal'
import PrivacyNoticeModal from '@/components/modals/PrivacyNoticeModal'
export default {
  components: {
    UpdatePasswordModal,
    TermsOfUseModal,
    PrivacyNoticeModal
  },
  data () {
    return {
      passwordModalActive: false,
      showTermsOfUseModal: false,
      showPrivacyNoticeModal: false
    }
  },
  methods: {
    navigate (routeName) {
      this.$router.push({ name: routeName })
    },
    isActive (routeName) {
      return this.$route.matched.some(({ name }) => name === routeName)
    }
  }
}
</script>
